import React from 'react';
import { Field } from 'redux-form';
import moment from 'moment';
import { ReduxFormSelect } from '@common/components/FormElements';
import { NameDateOption } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/Options.styles';
import { useIsWindowWiderThan } from '@common/hooks';
import { gridTheme } from '@utils/grid';

const optionsForPerDateRange = (options, isMobile) => {
  return options.map((option, index) => {
    const startDate = moment(option.startDate).format('MMM DD');
    const endDate = moment(option.endDate).format('MMM DD');
    const labelDate = startDate === endDate ? startDate : `${startDate} - ${endDate}`;

    return {
      label: isMobile ? (
        `${labelDate}: ${option.name}`
      ) : (
        <NameDateOption>
          <strong>{option.name}</strong> {labelDate}
        </NameDateOption>
      ),
      value: index,
    };
  });
};

export const PerDateRange = ({ id, options }) => (
  <Field
    component={ReduxFormSelect}
    name={`extras.${id}.option`}
    options={optionsForPerDateRange(options, !useIsWindowWiderThan(gridTheme.breakpoints.md))}
  />
);
